import { useState, useEffect } from 'react';
import api from '../../../services/api';
import DataTable from '../componentes/DataTable';
import EditModal from '../componentes/EditModal';
import DeleteConfirm from '../componentes/DeleteConfirm';
import { Plus } from 'lucide-react';

const ProductosPanel = () => {
  const [productos, setProductos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selected, setSelected] = useState(null);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [imagenes, setImagenes] = useState({ imagen1: null, imagen2: null, imagen3: null });

  const fetchProductos = async () => {
    try {
      setLoading(true);
      const res = await api.get('/productos');
      setProductos(res.data?.data || res.data || []);
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchProductos(); }, []);

  const handleEdit = (p) => {
    setSelected({ ...p });
    setImagenes({ imagen1: null, imagen2: null, imagen3: null });
    setShowEdit(true);
  };

  const handleCreate = () => {
    setSelected(null);
    setImagenes({ imagen1: null, imagen2: null, imagen3: null });
    setShowEdit(true);
  };

  const handleDelete = (id) => {
    setSelected(productos.find(p => p.id === id));
    setShowDelete(true);
  };

  const handleSave = async (formData) => {
    let productoId = selected?.id;
    const payload = {
      titulo: formData.titulo,
      descripcion: formData.descripcion,
      precio: formData.precio,
      oferta: formData.oferta || 0,
      activo: formData.activo || 1,
    };

    if (selected) {
      await api.put(`/productos/${selected.id}`, payload);
    } else {
      const res = await api.post('/productos', payload);
      productoId = res.data?.id || res.data?.producto?.id;
      if (!productoId) throw new Error('No se pudo crear el producto');
    }

    // Subir imágenes si hay nuevas
    const imgForm = new FormData();
    let hasImages = false;
    if (imagenes.imagen1) { imgForm.append('imagen1', imagenes.imagen1); hasImages = true; }
    if (imagenes.imagen2) { imgForm.append('imagen2', imagenes.imagen2); hasImages = true; }
    if (imagenes.imagen3) { imgForm.append('imagen3', imagenes.imagen3); hasImages = true; }

    if (hasImages) {
      await api.post(`/upload-producto/${productoId}`, imgForm);
    }

    setShowEdit(false);
    fetchProductos();
  };

  const confirmDelete = async () => {
    await api.delete(`/productos/${selected.id}`);
    setShowDelete(false);
    fetchProductos();
  };

  const columns = [
    { key: 'id', label: 'ID' },
    { key: 'titulo', label: 'Título' },
    { key: 'precio', label: 'Precio', render: (v) => `$${parseFloat(v).toFixed(2)}` },
    { key: 'oferta', label: 'En oferta', render: (v) => v == 1 ? 'Sí' : 'No' },
    { key: 'activo', label: 'Activo', render: (v) => v == 1 ? 'Sí' : 'No' },
  ];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.25rem' }}>
        <h1 style={{ fontSize: '1.5rem', fontWeight: 800 }}>Productos</h1>
        <button className="sp-btn sp-btn--primary" onClick={handleCreate}>
          <Plus size={18} /> Nuevo
        </button>
      </div>

      <DataTable
        columns={columns}
        data={productos}
        loading={loading}
        error={error}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />

      {showEdit && (
        <EditModal
          title={selected ? 'Editar producto' : 'Crear producto'}
          fields={[
            { name: 'titulo', label: 'Título' },
            { name: 'descripcion', label: 'Descripción', type: 'textarea' },
            { name: 'precio', label: 'Precio', type: 'number', step: '0.01' },
            { name: 'oferta', label: 'En oferta', type: 'checkbox' },
            { name: 'activo', label: 'Activo', type: 'checkbox' },
            { name: 'imagen1', label: 'Imagen 1', type: 'file', accept: 'image/*', onChange: (e) => setImagenes(prev => ({ ...prev, imagen1: e.target.files[0] })) },
            { name: 'imagen2', label: 'Imagen 2', type: 'file', accept: 'image/*', onChange: (e) => setImagenes(prev => ({ ...prev, imagen2: e.target.files[0] })) },
            { name: 'imagen3', label: 'Imagen 3', type: 'file', accept: 'image/*', onChange: (e) => setImagenes(prev => ({ ...prev, imagen3: e.target.files[0] })) },
          ]}
          initialValues={selected || {}}
          onSave={handleSave}
          onCancel={() => setShowEdit(false)}
        />
      )}

      {showDelete && (
        <DeleteConfirm
          message={`¿Eliminar el producto "${selected.titulo}"?`}
          onConfirm={confirmDelete}
          onCancel={() => setShowDelete(false)}
        />
      )}
    </div>
  );
};

export default ProductosPanel;